// Generated types for PDMItemFlow
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ItemDefinitionReadAPI, ItemDefinitionWriteAPI } from '../../sysml/types/itemdefinition';
import { ItemDefinitionReadAPISchemaObject, ItemDefinitionWriteAPISchemaObject } from '../../sysml/types/itemdefinition';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PDMItemFlowReadAPI extends ItemDefinitionReadAPI {
  /** Type of flow: ENERGY, MATTER, INFORMATION, CONTROL */
  flow_type: string;
  /** Flow rate value as string */
  flow_rate_value?: string | null;
  /** Flow rate units */
  flow_rate_units?: string | null;
}

export interface PDMItemFlowWriteAPI extends ItemDefinitionWriteAPI {
  /** Type of flow: ENERGY, MATTER, INFORMATION, CONTROL */
  flow_type: string;
  /** Flow rate value as string */
  flow_rate_value?: string | null;
  /** Flow rate units */
  flow_rate_units?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PDMItemFlowReadAPISchema: z.ZodType<PDMItemFlowReadAPI> = ItemDefinitionReadAPISchemaObject.extend({
  flow_type: z.string(),
  flow_rate_value: z.string().nullable().optional(),
  flow_rate_units: z.string().nullable().optional(),
}).passthrough();

export const PDMItemFlowWriteAPISchema: z.ZodType<PDMItemFlowWriteAPI> = ItemDefinitionWriteAPISchemaObject.extend({
  flow_type: z.string(),
  flow_rate_value: z.string().nullable().optional(),
  flow_rate_units: z.string().nullable().optional(),
}).passthrough();
